import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-search\"><path d=\"M10 3c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3m0-1C7.8 2 6 3.8 6 6s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4\" /><path d=\"m6.8 7.8-4.5 4.5c-.4.4-.4 1 0 1.4s1 .4 1.4 0l4.5-4.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol